import { CreateVideoAndInitiateUploadDto } from '@greco/videos';
import { IsNotEmpty, IsString } from 'class-validator';

export class UploadCollectionVideoDto extends CreateVideoAndInitiateUploadDto {
  @IsString()
  @IsNotEmpty()
  subCollectionId: string;
}
